import { Skeleton } from 'src/shared/components/ui/miscellaneous/skeleton'

const NotificationSkeleton = () => {
  return (
    <div className="flex min-h-[72px] w-full items-center gap-4 border-y border-lightBorder bg-white px-4 py-[15px]">
      <Skeleton className="size-10 rounded-full" />
      <div className="flex flex-1 flex-col gap-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-20" />
      </div>
      <Skeleton className="h-3 w-10" />
    </div>
  )
}

export default NotificationSkeleton
